module.exports = __webpack_public_path__ + "static/media/B28375-DisciplineAllegationsStatement.4a1abb0b.pdf";